import axios from "axios";
import { useItemStore } from "@/stores/items";
import type { Item } from "@/stores/items";

const baseUrl = import.meta.env.DEV
  ? "https://balticsea.localhost/wp-json/balticsea/v1/"
  : "/wp-json/balticsea/v1/";

export interface Response {
  (data: any): void;
}

type Params = {
  lang: string;
  primary?: string;
  secondary?: string;
  mustHave?: string;
  mustHaveTaxonomy?: string;
  search?: string;
  order?: string;
  page?: number;
  year?: number;
  month?: number;
  orderBy?: string;
};

export const searchPosts = () => {
  const itemStore = useItemStore();

  const params: Params = {
    lang: itemStore.lang,
    primary: itemStore.filter.primary.join(),
    secondary: itemStore.filter.secondary.join(),
    mustHave: itemStore.mustHave,
    mustHaveTaxonomy: itemStore.taxonomy.secondary,
    search: itemStore.search,
    order: itemStore.sort ? (itemStore.asc ? "asc" : "desc") : "",
    page: itemStore.page,
    year: itemStore.year,
    month: itemStore.month,
    orderBy: itemStore.getOrderBy,
  };
  axios
    .get(baseUrl + "search/" + itemStore.type, { params })
    .then((response) => {
      (response.data as Array<Item>).forEach((item) => {
        itemStore.addItem(item);
      });
      if (response.data.length === 0) {
        itemStore.page = 0;
      }
    })
    .catch((reason) => {
      console.debug(reason);
    });
};

export const fetchCat = (cat: string) => {
  const itemStore = useItemStore();

  const params: Params = {
    lang: itemStore.lang,
    mustHave: itemStore.mustHave,
    mustHaveTaxonomy: itemStore.taxonomy.secondary,
  };

  axios
    .get(baseUrl + "cat/" + cat, { params })
    .then((response) => {
      itemStore.addCats(response.data, cat);
    })
    .catch((reason) => {
      console.debug(reason);
    });
};

export const fetchMonth = () => {
  const itemStore = useItemStore();

  const params = {
    lang: itemStore.lang,
    mustHave: itemStore.mustHave,
    mustHaveTaxonomy: itemStore.taxonomy.secondary,
  };
  axios
    .get(baseUrl + "months/" + itemStore.type, { params })
    .then((response) => {
      itemStore.months = response.data;
    })
    .catch((reason) => {
      console.debug(reason);
    });
};
